var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgD221(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 39,
    viewBox: "0 0 36 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_102_1590)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4057 11.1726C28.9925 10.3304 29.3366 9.30641 29.3366 8.2021C29.3366 5.32906 27.0076 3 24.1345 3C22.8209 3 21.621 3.4869 20.7054 4.29007C20.1795 3.85511 19.6083 3.47294 19 3.15166C20.3065 1.82355 22.1243 1 24.1345 1C28.1121 1 31.3366 4.22449 31.3366 8.2021C31.3366 9.98988 30.6852 11.6255 29.6068 12.8846C29.2929 12.254 28.8866 11.6774 28.4057 11.1726Z",
    fill: "url(#paint0_linear_102_1590)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 15L19.2565 15.5204L19.4142 16.4142L18.5204 16.2565L18 17L17.4796 16.2565L16.5858 16.4142L16.7435 15.5204L16 15L16.7435 14.4796L16.5858 13.5858L17.4796 13.7435L18 13L18.5204 13.7435L19.4142 13.5858L19.2565 14.4796L20 15ZM15.2565 18.5204L16 18L15.2565 17.4796L15.4142 16.5858L14.5204 16.7435L14 16L13.4796 16.7435L12.5858 16.5858L12.7435 17.4796L12 18L12.7435 18.5204L12.5858 19.4142L13.4796 19.2565L14 20L14.5204 19.2565L15.4142 19.4142L15.2565 18.5204ZM19.2565 21.5204L20 21L19.2565 20.4796L19.4142 19.5858L18.5204 19.7435L18 19L17.4796 19.7435L16.5858 19.5858L16.7435 20.4796L16 21L16.7435 21.5204L16.5858 22.4142L17.4796 22.2565L18 23L18.5204 22.2565L19.4142 22.4142L19.2565 21.5204ZM23.2565 18.5204L24 18L23.2565 17.4796L23.4142 16.5858L22.5204 16.7435L22 16L21.4796 16.7435L20.5858 16.5858L20.7435 17.4796L20 18L20.7435 18.5204L20.5858 19.4142L21.4796 19.2565L22 20L22.5204 19.2565L23.4142 19.4142L23.2565 18.5204Z",
    fill: "url(#paint1_linear_102_1590)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 23.3473C6.91752 21.8163 4 17.7615 4 13C4 6.92487 8.74949 2 14.6083 2C19.469 2 23.5661 5.38976 24.821 10.0139C24.9626 10.0047 25.1054 10 25.2493 10C28.9776 10 32 13.134 32 17C32 20.6028 29.375 23.57 26 23.9572V21.937C28.2205 21.5615 30 19.5486 30 17C30 14.1696 27.8053 12 25.2493 12C24.5272 12 23.8339 12.1732 23.2108 12.4855C23.1791 11.9037 23.0937 11.3367 22.9599 10.7899L22.9569 10.7911C22.0091 6.85004 18.5839 4 14.6083 4C9.92179 4 6 7.96046 6 13C6 16.6616 8.0703 19.7535 11 21.1706V23.3473Z",
    fill: "url(#paint2_linear_102_1590)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5021 28.0021C14.7442 28.0021 15.0022 27.7921 15.0021 27.456C15.0021 27.272 14.9389 26.9263 14.7435 26.4168C14.6656 26.2136 14.5746 26.0045 14.4744 25.7938C14.1753 26.4437 14.0015 27.0277 14.0017 27.456C14.0018 27.7921 14.2599 28.0021 14.5021 28.0021ZM13.2923 23.7572C13.9029 22.7302 14.5002 22 14.5002 22C14.5002 22 15.0699 22.7554 15.6655 23.7778C16.318 24.8977 17.0018 26.3379 17.0021 27.456C17.0025 28.8622 15.8835 30.0021 14.5027 30.0021C13.1218 30.0021 12.0021 28.8622 12.0017 27.456C12.0013 26.229 12.654 24.8309 13.2923 23.7572Z",
    fill: "url(#paint3_linear_102_1590)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5021 28.0021C21.7442 28.0021 22.0022 27.7921 22.0021 27.456C22.0021 27.272 21.9389 26.9263 21.7435 26.4168C21.6656 26.2136 21.5746 26.0045 21.4744 25.7938C21.1753 26.4437 21.0015 27.0277 21.0017 27.456C21.0018 27.7921 21.2599 28.0021 21.5021 28.0021ZM20.2923 23.7572C20.9029 22.7302 21.5002 22 21.5002 22C21.5002 22 22.0699 22.7554 22.6655 23.7778C23.318 24.8977 24.0018 26.3379 24.0021 27.456C24.0025 28.8622 22.8835 30.0021 21.5027 30.0021C20.1218 30.0021 19.0021 28.8622 19.0017 27.456C19.0013 26.229 19.654 24.8309 20.2923 23.7572Z",
    fill: "url(#paint4_linear_102_1590)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_102_1590",
    x: -2,
    y: 0,
    width: 40,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_102_1590"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_102_1590",
    result: "effect2_dropShadow_102_1590"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_102_1590",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_102_1590",
    x1: 25.1683,
    y1: 1,
    x2: 25.1683,
    y2: 12.8846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFC977"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E07256"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_102_1590",
    x1: 18,
    y1: 13,
    x2: 18,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2D4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9E2F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_102_1590",
    x1: 18,
    y1: 2,
    x2: 18,
    y2: 23.9572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2D4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9E2F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_102_1590",
    x1: 14.5002,
    y1: 22,
    x2: 14.5002,
    y2: 30.0021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#95B6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5193DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_102_1590",
    x1: 21.5002,
    y1: 22,
    x2: 21.5002,
    y2: 30.0021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#95B6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5193DE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgD221);
export default __webpack_public_path__ + "static/media/d221.03a9098b2d7c5298aee2fe22b4abca3b.svg";
export { ForwardRef as ReactComponent };